import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { InventoryService } from '../../services/index';

@Component({
  selector: 'app-asetmasters',
  templateUrl: './asetmasters.component.html',
  styleUrls: ['./asetmasters.component.scss'],
  providers:[InventoryService]
})
export class AsetmastersComponent implements OnInit {

  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;

  arrmjgrp:any=[];
  arrmngrp:any=[];
  asetmodel:any={};
  arrinvmunit:any=[];
  arrinvmstore:any=[];
  arrinvmstcat:any=[];
  arrinvmmnttype:any=[];
  arrinvmmfr:any=[];
  arrbrand:any=[];
  
  objmjgrp:any={};
  objmngrp:any={};
  objinvmunit:any={};
  objinvmstore:any={};
  objinvmstcat:any={};
  objinvmmnttype:any={};
  objinvmmfr:any={};
  objbrand:any={};


  status = [{id: 1,name: 'Active' },{id: 2,name: 'Inactive' }];

  statusyn = [{id: 1,name: 'Yes' },{id: 2,name: 'No' }];

  constructor(private iservice: InventoryService,private modalService: NgbModal) { }

  ngOnInit(): void {
    this.getinvmmnttype();
    this.getinvmstcat();
  }


  getinvmiga() {
    this.iservice.getinvmiga()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrmjgrp = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  getinvmigb() {
    this.iservice.getinvmigb()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrmngrp = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }


  getinvmbrand() {
    this.iservice.getinvmbrand()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrbrand = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }


  getinvmmfr() {
    this.iservice.getinvmmfr()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrinvmmfr = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }


  getinvmmnttype() {
    this.iservice.getinvmmnttype()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrinvmmnttype = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }

  getinvmstcat() {
    this.iservice.getinvmstcat()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrinvmstcat = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }


  getinvmstore() {
    this.iservice.getinvmstore()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrinvmstore = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }


  getinvmunit() {
    this.iservice.getinvmunit()
        .subscribe(
        resultArray => {
            console.log('getlibcategory', resultArray);
           // resultArray.forEach(x => x.status = x.status === 'true');
            this.arrinvmunit = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }


  openinvmmnttype(content,objdata,cmd) {
    if(cmd=='insert')
    {
      this.objinvmmnttype={};
      this.objinvmmnttype.mntid=0;
      this.objinvmmnttype.sorder=0;
      this.objinvmmnttype.crby=localStorage.getItem('usid');
      this.objinvmmnttype.mdby=0;
      //this.submodel.parentsubid=0;
      this.objinvmmnttype.oprtype='insert';
      this.objinvmmnttype.rstatus='Active';
      this.objinvmmnttype.mntnm='';
     
    

    }

    else if(cmd=='update')
    {
      this.objinvmmnttype=objdata;
      this.objinvmmnttype.mdby=localStorage.getItem('usid');
      this.objinvmmnttype.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'md'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }


  openinvmiga(content,objdata,cmd) {
    if(cmd=='insert')
    {
      this.objmjgrp={};
      this.objmjgrp.igida=0;
      // this.objmjgrp.sorder=0;
      this.objmjgrp.crby=localStorage.getItem('usid');
      this.objmjgrp.mdby=0;
      //this.submodel.parentsubid=0;
      this.objmjgrp.oprtype='insert';
      this.objmjgrp.rstatus='Active';
      this.objmjgrp.ignma='';
     
    

    }

    else if(cmd=='update')
    {
      this.objmjgrp=objdata;
      this.objmjgrp.mdby=localStorage.getItem('usid');
      this.objmjgrp.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'md'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }


  openinvmigb(content,objdata,cmd) {
    if(cmd=='insert')
    {
      this.objmngrp={};
      this.objmngrp.igidb=0;
      // this.objmjgrp.sorder=0;
      this.objmngrp.crby=localStorage.getItem('usid');
      this.objmngrp.mdby=0;
      //this.submodel.parentsubid=0;
      this.objmngrp.oprtype='insert';
      this.objmngrp.rstatus='Active';
      this.objmngrp.ignmb='';
     
    

    }

    else if(cmd=='update')
    {
      this.objmngrp=objdata;
      this.objmngrp.mdby=localStorage.getItem('usid');
      this.objmngrp.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'md'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }


  openinvmbrand(content,objdata,cmd) {
    if(cmd=='insert')
    {
      this.objbrand={};
      this.objbrand.bndid=0;
      // this.objmjgrp.sorder=0;
      this.objbrand.crby=localStorage.getItem('usid');
      this.objbrand.mdby=0;
      //this.submodel.parentsubid=0;
      this.objbrand.oprtype='insert';
      this.objbrand.rstatus='Active';
      this.objbrand.bndnm='';
     
    

    }

    else if(cmd=='update')
    {
      this.objbrand=objdata;
      this.objbrand.mdby=localStorage.getItem('usid');
      this.objbrand.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'md'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }


  openinvmmfr(content,objdata,cmd) {
    if(cmd=='insert')
    {
      this.objinvmmfr={};
      this.objinvmmfr.mfrid=0;
      // this.objmjgrp.sorder=0;
      this.objinvmmfr.crby=localStorage.getItem('usid');
      this.objinvmmfr.mdby=0;
      //this.submodel.parentsubid=0;
      this.objinvmmfr.oprtype='insert';
      this.objinvmmfr.rstatus='Active';
      this.objinvmmfr.mfrnm='';
     
    

    }

    else if(cmd=='update')
    {
      this.objinvmmfr=objdata;
      this.objinvmmfr.mdby=localStorage.getItem('usid');
      this.objinvmmfr.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'md'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }



  openinvmstcat(content,objdata,cmd) {
    if(cmd=='insert')
    {
      this.objinvmstcat={};
      this.objinvmstcat.stcatid=0;
      this.objinvmstcat.sorder=0;
      this.objinvmstcat.crby=localStorage.getItem('usid');
      this.objinvmstcat.mdby=0;
      //this.submodel.parentsubid=0;
      this.objinvmstcat.oprtype='insert';
      this.objinvmstcat.rstatus='Active';
      this.objinvmstcat.stcatnm='';
     
    

    }

    else if(cmd=='update')
    {
      this.objinvmstcat=objdata;
      this.objinvmstcat.mdby=localStorage.getItem('usid');
      this.objinvmstcat.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'md'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }


  openinvmstore(content,objdata,cmd) {
    if(cmd=='insert')
    {
      this.objinvmstore={};
      this.objinvmstore.stid=0;
      this.objinvmstore.stcatid=0;
      this.objinvmstore.sorder=0;
      this.objinvmstore.crby=localStorage.getItem('usid');
      this.objinvmstore.mdby=0;
      //this.submodel.parentsubid=0;
      this.objinvmstore.oprtype='insert';
      this.objinvmstore.rstatus='Active';
      this.objinvmstore.purc='Yes';
      this.objinvmstore.tran='Yes';
      this.objinvmstore.cons='Yes';
      this.objinvmstore.sale='Yes';
      this.objinvmstore.stnm='';
     
    

    }

    else if(cmd=='update')
    {
      this.objinvmstore=objdata;
      this.objinvmstore.mdby=localStorage.getItem('usid');
      this.objinvmstore.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'md'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }


  openinvmunit(content,objdata,cmd) {
    if(cmd=='insert')
    {
      this.objinvmunit={};
      this.objinvmunit.utid=0;
      this.objinvmunit.sorder=0;
      this.objinvmunit.crby=localStorage.getItem('usid');
      this.objinvmunit.mdby=0;
      //this.submodel.parentsubid=0;
      this.objinvmunit.oprtype='insert';
      this.objinvmunit.rstatus='Active';
      this.objinvmunit.utnm='';
     
    

    }

    else if(cmd=='update')
    {
      this.objinvmunit=objdata;
      this.objinvmunit.mdby=localStorage.getItem('usid');
      this.objinvmunit.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'md'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }

  Saveinvmmnttype()
  {
    console.log('catsave',this.objinvmmnttype);
    this.iservice.saveinvmmnttype(this.objinvmmnttype)
        .subscribe(
        result => {
            console.log('SavegenmasDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getinvmmnttype();
  
            }
           else
           {
  
           }
        },
        error =>{ alert('Error While saving...');}
        ) 
  }


  Saveinvmiga()
  {
    console.log('catsave',this.objmjgrp);
    this.iservice.saveinvmiga(this.objmjgrp)
        .subscribe(
        result => {
            console.log('SavegenmasDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getinvmiga();
  
            }
           else
           {
  
           }
        },
        error =>{ alert('Error While saving...');}
        ) 
  }


  Saveinvmigb()
  {
    console.log('catsave',this.objmngrp);
    this.iservice.saveinvmigb(this.objmngrp)
        .subscribe(
        result => {
            console.log('SavegenmasDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getinvmigb();
  
            }
           else
           {
  
           }
        },
        error =>{ alert('Error While saving...');}
        ) 
  }

  Saveinvmbrand()
  {
    console.log('catsave',this.objbrand);
    this.iservice.saveinvmbrand(this.objbrand)
        .subscribe(
        result => {
            console.log('SavegenmasDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getinvmbrand();
  
            }
           else
           {
  
           }
        },
        error =>{ alert('Error While saving...');}
        ) 
  }


  Saveinvmmfr()
  {
    console.log('catsave',this.objinvmmfr);
    this.iservice.saveinvmmfr(this.objinvmmfr)
        .subscribe(
        result => {
            console.log('SavegenmasDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getinvmmfr();
  
            }
           else
           {
  
           }
        },
        error =>{ alert('Error While saving...');}
        ) 
  }

  Saveinvmstcat()
  {
    console.log('catsave',this.objinvmstcat);
    this.iservice.saveinvmstcat(this.objinvmstcat)
        .subscribe(
        result => {
            console.log('SavegenmasDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getinvmstcat();
  
            }
           else
           {
  
           }
        },
        error =>{ alert('Error While saving...');}
        ) 
  }


  Saveinvmstore()
  {
    console.log('catsave',this.objinvmstore);
    this.iservice.saveinvmstore(this.objinvmstore)
        .subscribe(
        result => {
            console.log('SavegenmasDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getinvmstore();
  
            }
           else
           {
  
           }
        },
        error =>{ alert('Error While saving...');}
        ) 
  }


  Saveinvmunit()
  {
    console.log('catsave',this.objinvmunit);
    this.iservice.saveinvmunit(this.objinvmunit)
        .subscribe(
        result => {
            console.log('SavegenmasDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='Success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getinvmunit();
  
            }
           else
           {
  
           }
        },
        error =>{ alert('Error While saving...');}
        ) 
  }
}
